// Debug-related constants extracted to avoid circular dependencies
// This file should have no imports from other Graph modules
export const LS_SUBFLOWS_DEBUG_MODE_KEY = 'enable.subflows.debug.mode';
